import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wl-public-links-progress-dialog',
  templateUrl: './public-links-progress-dialog.component.html',
  styleUrl: './public-links-progress-dialog.component.less',
    standalone: false
})
export class PublicLinksProgressDialogComponent implements OnInit {
  showDialog: boolean = false;
  constructor(
  ) { }

  ngOnInit() { }
  public open() {
    this.showDialog = true;
  }

  public close() {
    this.showDialog = false;
  }
}
